import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getRevenues = createAsyncThunk(
  '/getRevenues',
  async () => {
    const response = await axios.get('/GetRevenues');
    return response.data;
  }
);

export const getRevenuePriceFutureChanges = createAsyncThunk(
  '/getRevenuePriceFutureChanges',
  async () => {
    const response = await axios.get('/GetRevenuePriceFutureChanges');
    return response.data;
  }
);

export const updateRevenue = createAsyncThunk(
  '/updateRevenue',
  async (req) => {
    const response = await axios.post(`/UpdateRevenue`, req);
    return response.data;
  }
);

const revenuePricesSlice = createSlice({
  name: 'revenuePrices',
  initialState: {
    loading: false,
    error: '',
    Revenues: [],
    RevenuePriceFutureChanges: []
  },
  reducers: { 
    resetDescriptions(state) {
      state.Revenues = [];
      state.RevenuePriceFutureChanges = [];
    
    }
  },
  extraReducers: {
    [getRevenues.pending]: (state) => {
      state.loading = true;
    },
    [getRevenues.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getRevenues.fulfilled]: (state, action) => {
      state.Revenues = action.payload;
      state.loading = false;
    },
    [getRevenuePriceFutureChanges.pending]: (state) => {
      state.loading = true;
    },
    [getRevenuePriceFutureChanges.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getRevenuePriceFutureChanges.fulfilled]: (state, action) => {
      state.RevenuePriceFutureChanges = action.payload;
      state.loading = false;
    },
    [updateRevenue.pending]: (state) => {
      state.loading = true;
    },
    [updateRevenue.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [updateRevenue.fulfilled]: (state) => {
      state.loading = false;
    }
  }
});

export const revenuePricesActions = revenuePricesSlice.actions;
export default revenuePricesSlice;